import React from "react";
import { HeroSliderItems } from "./hero-slider.component";

const HeroItem = (props) => {
  const { banner, title, short_desc } = props.slide;

  return (
    <div
      className="slide slide-one"
      style={{
        backgroundImage: `url(${banner})`,
        height: "620px",
      }}
    >
      <div className="container">
        <div className="row home-content">
          <div className="col-lg-12 text-center p0">
            <h3 className="banner-title">{title}</h3>
            <p>{short_desc}</p>
            <div className="btn">
              <a href="#" className="banner-btn">
                View Property
              </a>
              <a href="#" className="banner-btn">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroItem;
